export enum DetailsEntity {
    ZONING_CODE,
    ZONING_CODE_VERSION,
}
